import type { UndefinedOnPartialDeep } from 'type-fest';

import Text from '@ingka/text';
import { translate } from '@repo/phrase';
import type { CustomerData } from '@repo/types/customer';
import { type Service, isPickupServiceType } from '@repo/types/service';

import { formatDeliveryAddress } from '@/utils/services.utils';

interface Props {
    service: UndefinedOnPartialDeep<Service>;
    deliveryContact: UndefinedOnPartialDeep<CustomerData> | undefined;
}

export const ArticleDeliveryAddressText = ({ service, deliveryContact }: Props) => {
    const { serviceType, pickupPoint } = service;

    const deliveryAddressFallback = (
        <Text>{translate('services_article_delivery_view_delivery_address_not_found')}</Text>
    );

    if (!serviceType) {
        return deliveryAddressFallback;
    }

    let deliveryAdress;

    if (isPickupServiceType(serviceType) && pickupPoint) {
        deliveryAdress = (
            <>
                <Text>{pickupPoint.name}</Text>
                <Text>
                    {pickupPoint.address &&
                        formatDeliveryAddress({ ...pickupPoint.address, stateCode: pickupPoint.address.state })}
                </Text>
            </>
        );
    } else if (deliveryContact) {
        deliveryAdress = <Text>{formatDeliveryAddress(deliveryContact)}</Text>;
    } else {
        deliveryAdress = deliveryAddressFallback;
    }

    return <div data-testid={`article-delivery-address-${serviceType}`}>{deliveryAdress}</div>;
};
